<template>
  <!--  查看路线-->
  <div class="getStoreLocation">
    <div id="container" class="hHP wHP" />
  </div>
</template>

<script>
export default {
  name: "GetLocation",
  props: {
    deliveryId: {
      type: [String, Object, Array],
      default: "",
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    this.getDeliveryInfo(this.deliveryId);
  },
  methods: {
    getDeliveryInfo(id) {
      this.topsAjax.get(`${this.baseUrls.ordDelivery}/queryLocationList/` + id).then((res) => {
        if (res.length > 0) {
          var map = new AMap.Map("container", {
            resizeEnable: true,
            zoom: 15,
            center: [res[0].longitude, res[0].latitude],
          });
        }
        for (let i = 0; i < res.length; i++) {
          var marker = new AMap.Marker({
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
            position: [res[i].longitude, res[i].latitude],
            anchor: "bottom-center",
          });
          map.add(marker);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.getStoreLocation {
  height: 400px;
}
</style>
